module.exports = "../images/cabin-4-person-4.jpg?v=e375335";